module.exports = __webpack_public_path__ + "img/cats.54527cb7.jpg";